<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="panel-container">
    <div class="panel">
      <CircularButton
        class="back-btn"
        icon="long-arrow-alt-left"
        color="var(--light-clr)"
        @click="goBack"
      />
      <div class="user">
        <div class="user-info-panel">
          <div class="user-image">
            <img :src="user.profileImage" alt="User's Image" />
          </div>
          <div class="user-info">
            <div class="user-name">
              <h2>{{ user.firstName + " " + user.lastName }}</h2>
            </div>
            <div class="user-age">
              {{ user.age != 0 && user.age ? user.age + " y.o." : "-" }}
            </div>
          </div>
        </div>
      </div>
      <div class="pets-container">
        <div class="pet" v-for="pet in user.pets" :key="pet">
          <div class="pet-image">
            <img
              :src="backend + '/pets/images/' + pet._id"
              onerror="this.src='/paw.svg'"
              alt="Pets's Image"
            />
          </div>
          <div class="pet-info">
            <div class="pet-name">
              <h3>{{ pet.pet.name }}</h3>
            </div>
            <div class="pet-race">
              {{ pet.pet.type }} ({{ pet.pet.breed.replaceAll("_", " ") }})
            </div>
            <div class="pet-age">
              {{ pet.pet.age != 0 ? pet.pet.age + " y.o." : "-" }}
            </div>
            <div class="pet-behaviour">{{ pet.pet.behaviour }}</div>
            <div class="pet-size">{{ pet.pet.size }}</div>
          </div>
        </div>
      </div>
      <div class="call-to-action">
        <Button
          class="call-to-action-btn"
          color="var(--google-1)"
          text="Date2play"
          icon="baseball-ball"
          @click="meetUser('Walk')"
        />
        <Button
          class="call-to-action-btn"
          color="var(--google-2)"
          text="Date2learn"
          icon="question"
          @click="meetUser('Play')"
        />
      </div>
    </div>
  </div>
  <div id="myModal" class="modal">
    <!-- Modal content -->
    <div class="modal-content">
      <span class="close" @click="closeModalMounted">&times;</span>
      <h2>Pick a date</h2>
      <input type="datetime-local" v-model="user.meetDate" />
      <Button
        text="Ok"
        @click="
          closeModalMounted();
          setMeet();
        "
      />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

const query = window.location.search;
const getParameters = new URLSearchParams(query);

let jwt = localStorage.getItem("jwt");

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

function fetchUserData(self) {
  if (jwt == null) {
    self.$router.push("/");
  }

  if (getParameters.has("email")) {
    let userEmailID = getParameters.get("email");

    const headers = {
      Authorization: "Bearer " + jwt,
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info/${userEmailID}`, {
        headers: headers,
      })
      .then(function (res) {
        self.user.firstName = res.data.firstName;
        self.user.lastName = res.data.lastName;
        self.user.email = res.data.email;
        self.user.age = res.data.age;
        let title = `${self.user.firstName} ${self.user.lastName} - Dating4Pets`;
        document.title = title;
        if (validURL(res.data.profileImage)) {
          console.log(res.data.profileImage);
          self.user.profileImage = res.data.profileImage;
        } else {
          axios
            .get(
              `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`,
              {
                headers: headers,
              }
            )
            .then(function () {
              self.user.profileImage = `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`;
            })
            .catch(() => {
              self.user.profileImage = "/paw.svg";
            });
        }

        // FETCH USER'S PETS
        axios
          .get(`${process.env.VUE_APP_BACKEND}/pets/${self.user.email}`, {
            headers: headers,
          })
          .then(function (res) {
            self.user.pets = res.data;
          })
          .catch(() => {
            self.user.pets = {};
          });
        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch(function (err) {
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("An error occured", `${err}`, "error").then(() => {
            self.$router.push("/");
          });
        }
      });
  } else {
    self.$router.push("/");
  }
}

function openModal() {
  var modal = document.querySelector("#myModal");
  modal.style.display = "flex";
}

function closeModal() {
  var modal = document.querySelector("#myModal");
  modal.style.display = "none";
  console.log("Henlo", modal);
}

const Toast = Swal.mixin({
  toast: true,
  position: "bottom-right",
  showConfirmButton: false,
  timer: 5000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

let headers = {};

export default {
  name: "UserInfo",
  components: { Navbar, Button, CircularButton, LoadingScreen },
  mounted() {
    let title = "User Info - Dating4Pets";
    document.title = title;
    let self = this;
    this.backend = process.env.VUE_APP_BACKEND;
    fetchUserData(self);

    if (localStorage.getItem("jwt") == null) {
      self.$router.push("/");
    }

    headers = {
      Authorization: `Bearer ${jwt}`,
    };

    headers["content-type"] = "application/json";
  },
  data() {
    return {
      user: {
        firstName: "",
        lastName: "",
        age: "",
        email: "",
        profileImage: "",
        pets: {},
        lat: "",
        lon: "",
        meetDate: "",
        mode: "",
      },
      backend: "",
    };
  },
  methods: {
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
    meetUser(mode) {
      let self = this;
      self.user.mode = mode;

      Swal.fire({
        title: "Pick a location",
        html: "<iframe src='/location_picker.html' title='Test'></iframe> ",
        customClass: "swal-loc-picker",
      })
        .then((res) => {
          if (res.isConfirmed) {
            if (
              localStorage.getItem("userLat") &&
              localStorage.getItem("userLon")
            ) {
              self.user.lat = localStorage.getItem("userLat");
              self.user.lon = localStorage.getItem("userLon");

              openModal();
            } else {
              Swal.fire("You didn't pick a location.", "", "error").then(() => {
                return;
              });
            }
          } else {
            Swal.fire("You didn't pick a location.", "", "error").then(() => {
              return;
            });
          }
        })
        .catch((err) => {
          Swal.fire("An error occured.", `${err}`, "error").then(() => {
            return;
          });
        });

      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(
      //     function success(res) {
      // self.user.lon = res.coords.longitude;
      // self.user.lat = res.coords.latitude;

      // data["lon"] = Number.parseFloat(self.user.lon).toFixed(6);
      // data["lat"] = Number.parseFloat(self.user.lat).toFixed(6);

      // },
      // function failure(err) {
      //   Toast.fire({
      //     icon: "error",
      //     title:
      //       "Sorry... There was an error while trying to get your position. Error: " +
      //       err.message,
      //   }).then(() => {
      //     return;
      //   });
      // }
      // );
      // } else {
      //   Toast.fire({
      //     icon: "error",
      //     title: "Sorry... Geolocation is not supported by your browser.",
      //   }).then(() => {
      //     return;
      //   });
      // }
    },
    closeModalMounted() {
      closeModal();
    },
    openModalMounted() {
      openModal();
    },
    setMeet() {
      let self = this;
      let data = {
        to: `${self.user.email}`,
        location: `${self.user.lat},${self.user.lon}`,
        time: `${self.user.meetDate}`,
        mode: `${self.user.mode}`,
      };
      console.log(data);
      axios
        .post(`${process.env.VUE_APP_BACKEND}/walk/invite`, data, {
          headers: headers,
        })
        .then(function () {
          Toast.fire({
            icon: "success",
            title: "Your invitation has been sent successfully.",
          });
        })
        .catch(function (err) {
          Toast.fire({
            icon: "error",
            title: "There was an error sending your invitation.",
            text: err,
          }).then(() => {});
        });
    },
  },
};
</script>

<style scoped>
* {
  overflow: visible;
}
.panel-container {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;
  margin-block: 5em;
  width: 100%;
}

.panel {
  min-width: 15em;
  width: 80%;
  max-width: 80em;
  background: var(--light-clr);
  border-radius: 1em;
  box-shadow: var(--light-box-shadow);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2em;

  position: relative;
  /* FOR TESTING */
}

.call-to-action {
  display: flex;
  flex-direction: row;
  /* height: 2em; */
  gap: var(--gap);
  color: var(--light-clr);
  margin-block-start: 2em;
}

.call-to-action-btn {
  width: 100%;
}

.button-text {
  color: var(--light-clr);
}

.user {
  margin: 2em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.user-image {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1;
  min-width: 10em;
  max-width: 15em;
}
.user-image img {
  width: 100%;
}

.user-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap);
}
.user-info-panel {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: var(--gap);
}

.pets-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 5em;
  width: 80%;
  max-width: 35em;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(10em, 2fr));
  grid-gap: 2em;
}

.pet-image {
  width: 7em;
  aspect-ratio: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  overflow: hidden;
  background: var(--light-clr);
}
.pet {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--gap);
}

.pet-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.pet-image img {
  width: 100%;
}

.back-btn {
  position: absolute;
  left: 0;
  top: 0;
  margin: 2em;
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transition: var(--transition);
}

@media screen and (max-width: 30rem) {
}

@media screen and (max-width: 46rem) {
  .call-to-action {
    flex-direction: column;
  }
}

@media screen and (max-width: 54rem) {
}

.modal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1000; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%;
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  /* display: flex; */
  align-items: center;
  justify-content: center;
}

/* Modal Content/Box */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto; /* 15% from the top and centered */
  padding: 20px;
  width: 80%; /* Could be more or less, depending on screen size */
  max-width: 35em;
  padding: 2em;
  position: relative;
  box-shadow: var(--light-box-shadow);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2em;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  position: absolute;
  top: 0;
  right: 0;
  padding: 0.5em;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

input {
  height: 2rem;
  width: inherit;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
  min-width: 17em;
  width: 50%;
  max-width: 35em;
}
</style>
